export default __webpack_public_path__ + "static/media/capri1.50e84c6d.png";